export const Permission = {
  VIEW_FACILITIES_DATA: "view_facilities_data",
  VIEW_COMPANY_DATA: "view_company_data",
  VIEW_DASHBOARD: "view_dashboard",
  EDIT_FACILITY_NAME: "edit_facility_name",
  EDIT_FACILITY_ADDRESS: "edit_facility_address",
  EDIT_FACILITY_LABELS: "edit_facility_labels",
  EDIT_FACILITY_HOURS: "edit_facility_hours",
  EDIT_FACILITY_DESCRIPTION: "edit_facility_description",
  EDIT_FACILITY_OPENING_DATE: "edit_facility_opening_date",
  EDIT_FACILITY_OPEN_STATUS: "edit_facility_open_status",
  EDIT_FACILITY_ATTRIBUTES: "edit_facility_attributes",
  EDIT_FACILITY_WEBSITE: "edit_facility_website",
  EDIT_FACILITY_PHONE_NUMBER: "edit_facility_phone_number",
  EDIT_FACILITY_PRIMARY_CATEGORY: "edit_facility_primary_category",
  EDIT_FACILITY_ADDITIONAL_CATEGORIES: "edit_facility_additional_categories",
  EDIT_FACILITY_STORE_CODE: "edit_facility_store_code",
  EDIT_FACILITY_SERVICE_ITEMS: "edit_facility_service_items",
  VIEW_EXTERNAL_CHANGES: "view_external_changes",
  APPROVE_AND_REJECT_EXTERNAL_CHANGES: "approve_and_reject_external_changes",
  VIEW_EXTERNAL_CHANGES_HISTORY: "view_external_changes_history",
  PROTECT_FROM_EXTERNAL_CHANGES: "protect_from_external_changes",
  ADD_AND_DELETE_LOCAL_POSTS: "add_and_delete_local_posts",
  VIEW_LOCAL_POSTS: "view_local_posts",
  ADD_AND_DELETE_PHOTOS: "add_and_delete_photos",
  VIEW_PHOTOS: "view_photos",
  VIEW_AND_REPORT_CUSTOMER_MEDIA: "view_and_report_customer_media",
  ASSESS_CUSTOMER_MEDIA: "assess_customer_media",
  VIEW_REVIEWS_ANALYTICS: "view_reviews_analytics",
  VIEW_REVIEWS: "view_reviews",
  REPLY_REVIEWS: "reply_reviews",
  VIEW_GMB_INSIGHTS: "view_gmb_insights",
  VIEW_MAPS_RANKINGS: "view_maps_rankings",
  VIEW_MAPS_COMPETITION_RANKINGS: "view_maps_competition_rankings",
  MANAGE_COMPETITION_PLACES: "manage_competition_places",
  MANAGE_KEYWORDS: "manage_keywords",
  MANAGE_GMB_ACCOUNT: "manage_gmb_account",
  MANAGE_EXTERNAL_GMB_ADDRESSES: "manage_external_gmb_addresses",
  VIEW_TEAM: "view_team",
  MANAGE_TEAM: "manage_team",
  MANAGE_REVIEWS_CATEGORIES: "manage_reviews_categories",
  ASSIGN_REVIEWS_CATEGORIES: "assign_reviews_categories",
  MANAGE_COMPANY_DATA: "manage_company_data",
  MANAGE_STORE_LOCATOR: "manage_store_locator",
  VIEW_RB_REVIEWS: "view_rb_reviews",
  VIEW_RB_REVIEWS_ANALYTICS: "view_rb_reviews_analytics",
  VIEW_RB_FORMS: "view_rb_forms",
  CONFIGURE_AI_REVIEW_REPLY: "configure_ai_review_reply",
  CONFIGURE_AI_MEDIA_ASSESSMENT: "configure_ai_media_assessment",
  MANAGE_GOOGLE_PLAY_ACCOUNT: "manage_google_play_account",
  VIEW_Q_AND_A: "view_q_and_a",
  ADD_AND_EDIT_Q_AND_A: "add_and_edit_q_and_a",
  DELETE_Q_AND_A: "delete_q_and_a"
};
